import KinvaDocList from './KinvaDocList'
export {KinvaDocList}
export default KinvaDocList
